import { toast } from "sonner";
export async function postBankData(teacherData) {
    const url = `${process.env.REACT_APP_API_URL}/admin/profesorbanco/crear`;
    const token = sessionStorage.getItem('token');

    try {
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(teacherData)
        });

        const contentType = response.headers.get('content-type');
        const responseText = await response.text();

        if (!response.ok) {
            toast.error("Error al crear información bancaria del profesor");    
            console.error('Server responded with:', responseText);
            throw new Error('Failed to create bank data');
        }

        if (contentType && contentType.includes('application/json')) {
            return JSON.parse(responseText);
        } else {
            toast.success("Información bancaria creada con éxito");
            return { message: responseText };
        }
    } catch (error) {
        toast.error("Error al crear información bancaria del profesor");
        console.error('Error creating bank data:', error);
        throw error;
    }
}

